export default __webpack_public_path__ + "src/assets/tools.d6a15d833391d9687daa06f3c6ea2d24.svg";